// Average the upper revenue estimate across the API's 12-month window.
// Guarded so a missing/empty window returns 0 instead of throwing — the
// un-guarded metrics.forEach was the submit-crash bug: when the estimate
// call returned false/undefined, submit threw and never reached
// navigate('/pricing/result/'), leaving the user stuck on the form.
function calculateEstimate(metrics) {
  if (!Array.isArray(metrics) || metrics.length === 0) {
    return 0;
  }
  const total = metrics.reduce(
    (sum, metric) => sum + (Number(metric && metric.revenue_upper) || 0),
    0
  );
  // Divide by 12 to match the original calculation (rolling 12-month window).
  return Math.ceil(total / 12);
}

module.exports = { calculateEstimate };